/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _qty_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);


var selectors = {
  variantSelector: '[data-product-select]',
  decrementQtyBtn: '[data-decrement-qty]',
  incrementQtyBtn: '[data-increment-qty]',
  qtyInput: '[data-qty-input]',
  addButton: '.product-card__add',
  addedLabel: '.product-card__added',
  noSide: '.no-side-cart'
};
var cssClasses = {
  show: 'show'
};

function ProductCard(container) {
  var _variantSelector$opti;

  var variantSelector = container.querySelector(selectors.variantSelector);
  var qtyInput = container.querySelector(selectors.qtyInput);
  if (!variantSelector || !qtyInput) return;
  var selectedVariantId = (_variantSelector$opti = variantSelector.options[variantSelector.selectedIndex]) === null || _variantSelector$opti === void 0 ? void 0 : _variantSelector$opti.value;
  (0,_qty_selector__WEBPACK_IMPORTED_MODULE_1__.default)(container.querySelector(selectors.decrementQtyBtn), container.querySelector(selectors.incrementQtyBtn), container.querySelector(selectors.qtyInput));
  container.addEventListener('click', function (evt) {
    var _window$sideCart;

    var target = evt.target;
    var addButton = target.closest(selectors.addButton);
    if (!addButton || addButton.disabled) return;
    evt.preventDefault();
    var addedLabel = container.querySelector(selectors.addedLabel);
    var noSideCart = container.querySelector(selectors.noSide);
    var item = {
      id: selectedVariantId,
      quantity: qtyInput.value
    };
    (_window$sideCart = window.sideCart) === null || _window$sideCart === void 0 ? void 0 : _window$sideCart.handleAddToCartEvent(item, !noSideCart);
    addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.add(cssClasses.show);
    setTimeout(function () {
      addedLabel === null || addedLabel === void 0 ? void 0 : addedLabel.classList.remove(cssClasses.show);
    }, 2000);
  });
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCard);

/***/ }),

/***/ 178:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_0__);


var qtySelector = function qtySelector(decrementBtn, incrementBtn, input) {
  if (!decrementBtn || !incrementBtn || !input) return;
  var inputMin = Number(input.getAttribute('min'));
  decrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) - 1;

    if (newQty <= 0) {
      return;
    }

    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    }
  });
  incrementBtn.addEventListener('click', function () {
    var newQty = Number(input.value) + 1;
    input.value = Number(newQty);
    input.dispatchEvent(new Event('change'));

    if (newQty > inputMin) {
      decrementBtn.removeAttribute('disabled');
    }
  });
  input.addEventListener('input', function () {
    if (input.value <= inputMin) {
      decrementBtn.setAttribute('disabled', '');
    } else {
      decrementBtn.removeAttribute('disabled');
    }
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (qtySelector);

/***/ }),

/***/ 260:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(123);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(142);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(124);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(179);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(90);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(132);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(135);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(229);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(95);
/* harmony import */ var core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(2);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(153);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(172);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(176);










var _window$Shopify, _window$Shopify$theme, _window$Shopify$theme2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }











/* global van11yAccessibleTabPanelAria */



 // Fix for equal height cells when resizing (https://codepen.io/desandro/pen/ZXEGVq)

(flickity__WEBPACK_IMPORTED_MODULE_20___default().prototype._createResizeClass) = function () {
  this.element.classList.add('flickity-resize');
};

flickity__WEBPACK_IMPORTED_MODULE_20___default().createMethods.push('_createResizeClass');
var resize = (flickity__WEBPACK_IMPORTED_MODULE_20___default().prototype.resize);

(flickity__WEBPACK_IMPORTED_MODULE_20___default().prototype.resize) = function () {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

var selectors = {
  tabs: '.js-tabs',
  tabLink: '.js-tablist__link',
  slider: '.carousel',
  progressBar: '.progress-bar__progress',
  recommendationsWrapper: '[data-recommendations-wrapper]',
  recommendationsSlider: '[data-recommendations-slider]',
  recommendationsProgressBar: '[data-recommendations-progress-bar]',
  recentlyViewedSlider: '[data-recently-viewed-slider]',
  recentlyViewedProgressBar: '[data-recently-viewed-progress-bar]',
  productCard: '[data-product-card]'
};
var sectionType = 'product-recommendations';
var registeredSections = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : (_window$Shopify$theme = _window$Shopify.theme) === null || _window$Shopify$theme === void 0 ? void 0 : (_window$Shopify$theme2 = _window$Shopify$theme.sections) === null || _window$Shopify$theme2 === void 0 ? void 0 : _window$Shopify$theme2.registered) || {};
var isUnregistered = typeof registeredSections[sectionType] === 'undefined';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isUnregistered && (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__.register)(sectionType, {
  onLoad: function onLoad() {
    var container = this.container;
    var productId = container.dataset.productId;
    var productHandle = container.dataset.productHandle;
    var limit = Number(container.dataset.limit);
    var rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;

    var initRecommendations = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var recommendationsWrapper, requestUrl, response, data, fragment, responseSlider, responseProgressBar, sliderContainer, productCards, slider;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                recommendationsWrapper = container.querySelector(selectors.recommendationsWrapper);

                if (!recommendationsWrapper) {
                  _context.next = 17;
                  break;
                }

                requestUrl = "".concat(rootUrl, "/recommendations/products?section_id=product-recommendations&limit=").concat(limit, "&product_id=").concat(productId);
                _context.next = 5;
                return fetch(requestUrl);

              case 5:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _context.next = 10;
                return response.text();

              case 10:
                data = _context.sent;
                fragment = document.createRange().createContextualFragment(data);
                responseSlider = fragment === null || fragment === void 0 ? void 0 : fragment.querySelector(selectors.recommendationsSlider);
                responseProgressBar = fragment === null || fragment === void 0 ? void 0 : fragment.querySelector(selectors.recommendationsProgressBar);

                if (!(!responseSlider || !responseProgressBar)) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return");

              case 16:
                if ('replaceChildren' in HTMLElement.prototype) {
                  recommendationsWrapper.replaceChildren(responseSlider, responseProgressBar);
                } else {
                  recommendationsWrapper.childNodes.forEach(function (node) {
                    return node.remove();
                  });
                  recommendationsWrapper.appendChild(responseSlider);
                  recommendationsWrapper.appendChild(responseProgressBar);
                }

              case 17:
                sliderContainer = container.querySelector(selectors.recommendationsSlider);

                if (sliderContainer) {
                  _context.next = 20;
                  break;
                }

                return _context.abrupt("return");

              case 20:
                productCards = sliderContainer.querySelectorAll(selectors.productCard);

                if (productCards) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return");

              case 23:
                productCards.forEach(function (product) {
                  return (0,_components_product_card__WEBPACK_IMPORTED_MODULE_22__.default)(product);
                }); // eslint-disable-next-line no-unused-vars

                slider = new (flickity__WEBPACK_IMPORTED_MODULE_20___default())(sliderContainer, {
                  draggable: true,
                  freeScroll: false,
                  prevNextButtons: false,
                  pageDots: false,
                  imagesLoaded: true,
                  setGallerySize: true,
                  cellAlign: 'left',
                  groupCells: true,
                  contain: true,
                  watchCSS: true,
                  on: {
                    scroll: function scroll(progress) {
                      var _this$element, _this$element$nextEle;

                      var progressBar = (_this$element = this.element) === null || _this$element === void 0 ? void 0 : (_this$element$nextEle = _this$element.nextElementSibling) === null || _this$element$nextEle === void 0 ? void 0 : _this$element$nextEle.querySelector(selectors.progressBar);
                      if (!progressBar) return;
                      var cappedProgress = Math.max(0, Math.min(1, progress));
                      var numberOfSlides = this.slides.length;
                      var progressOffset = 1 / numberOfSlides;
                      var adjustedProgress = (1 - progressOffset) * cappedProgress + progressOffset;
                      progressBar.style.width = "".concat(adjustedProgress * 100, "%");
                    }
                  }
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initRecommendations() {
        return _ref.apply(this, arguments);
      };
    }();

    var initRecentlyViewed = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var recentProducts, newRecentProducts, markupArray, _iterator, _step, item, url, response, productMarkup, markup, sliderContainer, productCards, slider;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /**
                 * - Retrieve the recent products array from localStorage.
                 * - Move the current product to the front of the array.
                 * - Trim the length of the array to keep things tidy.
                 * - Update the localStorage item with the new array.
                 */
                recentProducts = JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
                newRecentProducts = recentProducts.filter(function (item) {
                  return item !== productHandle;
                });

                if (productHandle) {
                  newRecentProducts.unshift(productHandle);
                }

                newRecentProducts.length = Math.min(newRecentProducts.length, limit * 2);
                localStorage.setItem('recently_viewed_products', JSON.stringify(newRecentProducts));
                /**
                 * If there are no recent products to show besides the current one,
                 * do nothing.
                 */

                if (!(newRecentProducts.length === 1)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                /**
                 * Loop through the recent products array and:
                 * - Fetch the product card markup for each item
                 * - Append the markup to an array
                 * - Stop once the array reaches the `limit`
                 * - Join the array into a single string
                 */
                markupArray = [];
                _iterator = _createForOfIteratorHelper(newRecentProducts.slice(1));
                _context2.prev = 9;

                _iterator.s();

              case 11:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 33;
                  break;
                }

                item = _step.value;

                if (!(markupArray.length === limit)) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("break", 33);

              case 15:
                _context2.prev = 15;
                url = "".concat(rootUrl, "/products/").concat(item, "?view=recently-viewed");
                _context2.next = 19;
                return fetch(url);

              case 19:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 22;
                  break;
                }

                return _context2.abrupt("continue", 31);

              case 22:
                _context2.next = 24;
                return response.text();

              case 24:
                productMarkup = _context2.sent;
                markupArray.push(productMarkup);
                _context2.next = 31;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2["catch"](15);
                window.console.error("Recently viewed product does not exist: ".concat(item));

              case 31:
                _context2.next = 11;
                break;

              case 33:
                _context2.next = 38;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](9);

                _iterator.e(_context2.t1);

              case 38:
                _context2.prev = 38;

                _iterator.f();

                return _context2.finish(38);

              case 41:
                if (!(markupArray.length === 0)) {
                  _context2.next = 43;
                  break;
                }

                return _context2.abrupt("return");

              case 43:
                markup = markupArray.join('');
                /**
                 * - Append the product card markup to the slider container
                 * - Initialise the product cards
                 * - Reveal the section, then initialise Flickity
                 */

                sliderContainer = container.querySelector(selectors.recentlyViewedSlider);

                if (sliderContainer) {
                  _context2.next = 47;
                  break;
                }

                return _context2.abrupt("return");

              case 47:
                sliderContainer.innerHTML = markup;
                productCards = sliderContainer.querySelectorAll(selectors.productCard);

                if (productCards) {
                  _context2.next = 51;
                  break;
                }

                return _context2.abrupt("return");

              case 51:
                productCards.forEach(function (product) {
                  return (0,_components_product_card__WEBPACK_IMPORTED_MODULE_22__.default)(product);
                }); // eslint-disable-next-line no-unused-vars

                slider = new (flickity__WEBPACK_IMPORTED_MODULE_20___default())(sliderContainer, {
                  draggable: true,
                  freeScroll: false,
                  prevNextButtons: false,
                  pageDots: false,
                  imagesLoaded: true,
                  setGallerySize: true,
                  cellAlign: 'left',
                  groupCells: true,
                  contain: true,
                  watchCSS: true,
                  on: {
                    scroll: function scroll(progress) {
                      var _this$element2, _this$element2$nextEl;

                      var progressBar = (_this$element2 = this.element) === null || _this$element2 === void 0 ? void 0 : (_this$element2$nextEl = _this$element2.nextElementSibling) === null || _this$element2$nextEl === void 0 ? void 0 : _this$element2$nextEl.querySelector(selectors.progressBar);
                      if (!progressBar) return;
                      var cappedProgress = Math.max(0, Math.min(1, progress));
                      var numberOfSlides = this.slides.length;
                      var progressOffset = 1 / numberOfSlides;
                      var adjustedProgress = (1 - progressOffset) * cappedProgress + progressOffset;
                      progressBar.style.width = "".concat(adjustedProgress * 100, "%");
                    }
                  }
                });

              case 53:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[9, 35, 38, 41], [15, 28]]);
      }));

      return function initRecentlyViewed() {
        return _ref2.apply(this, arguments);
      };
    }();

    initRecommendations();
    initRecentlyViewed(); // Event listener when tab links are clicked

    container.querySelectorAll(selectors.tabLink).forEach(function (link) {
      link.addEventListener('click', function () {
        var tabID = link.getAttribute('aria-controls');
        var tab = container.querySelector("#".concat(tabID)); // Resize and update flickity slider

        var slider = tab.querySelector(selectors.slider);
        if (!slider) return;
        var flickity = flickity__WEBPACK_IMPORTED_MODULE_20___default().data(slider);
        flickity === null || flickity === void 0 ? void 0 : flickity.resize();
      });
    }); // Only run in the admin theme customizer

    if (Shopify.designMode) {
      // Reinitialise tabs after adding/removing blocks
      var tabs = container.querySelector(selectors.tabs); // Only reinitialise if the tabs exist and tabs JS hasn't already run (it gives the tabs div an id)

      if (tabs && !tabs.id) {
        van11yAccessibleTabPanelAria(container);
      }
    }
  }
}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			32: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(260)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;